<template>
  <div
    class="card justify-content-between px-4 pb-4 lista around border-0 h-100"
  >
    <div>
      <div
        class="row pt-4 border-bottom pb-4 lista-items"
        v-for="(value, index) in list"
        :key="index"
      >
        <div class="col-md-9">
          <strong class="font-weight-bold">{{ value.desc }}</strong>
          <div>
            <small class="small">
              {{ value.info }}
            </small>
          </div>
          <div v-if="value.infoExtra">
            <small class="small">
              {{ value.infoExtra }}
            </small>
          </div>
        </div>
        <div class="col-md-3 text-muted text-left text-md-right mt-3 mt-md-0">
          <span class="preco">
            {{ value.value | currency }}
          </span>
        </div>
      </div>
    </div>
    <div class="total row align-bottom pt-4">
      <span class="col-md text-muted text-left text-md-right">
        <strong class="font-weight-bold">
          Total <span class="preco ml-2">{{ total | currency }}</span>
        </strong>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ItemCard",
  props: {
    title: {
      type: String,
      value: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      total: 0,
    };
  },
  filters: {
    currency(valor) {
      if (isNaN(valor)) {
        return "-";
      } else {
        var formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return formatter.format(valor);
      }
    },
  },
  watch: {
    async list(newlist) {
      newlist.forEach((el) => {
        this.total += el.value;
      });
    },
  },
  created() {
    this.list.forEach((el) => {
      this.total += el.value;
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.preco {
  white-space: nowrap;
}
.lista {
  .lista-items {
    .preco {
      font-weight: 700;
      color: #05428e;
    }
  }
}
.total {
  font-size: 1.2rem;
  .preco {
    font-weight: 700;
    color: #05428e;
  }
}
.item-card {
  text-align: center;
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px 10px;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  margin-right: 5px;
  .item-card-valor {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #000;
  }
  .item-card-titulo {
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
/* @media screen and (max-width: 768px) {
} */
</style>
